// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    PM_USERS_DELETE_USER_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    devicegetDataResult,
    usersSearchRolesResult,
    createPMUserResult,
    pmUsersGetUserResult,
    updatePMUserResult,
    deletePMUserResult,
} from 'Redux/actions';

// Helpers
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* deleteUsers({ payload }) {
    try {
        const { items } = payload;
        let mutations = [];

        items?.forEach((user, index) => {
            mutations.push(`
                Users${index}: deleteUser(id: ${user?.id})
            `);
        });

        let mutation = `mutation{${mutations.join("")}}`;

        const response = yield call(
            clientMutation,
            mutation,
            {},
            endpoints.GRAPHQL_GENERAL,
        );

        if (!response || !response.Users0) throw `Error while deleting Geofences, ${geofences}`;

        yield put(deletePMUserResult(response))

    } catch (exc) {
        ExceptionManager(
            exc,
            'Modules/pmUsers/.components/deleteUser/redux/saga',
            'deleteUsers'
        );
        put(deletePMUserResult({ error: true }))
    }
}

function* watchMethods() {
    yield takeEvery(PM_USERS_DELETE_USER_REQUEST, deleteUsers);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}